import React, { useEffect, useState } from "react";
import { CoursesTableRow } from "./CoursesTableRow";

export const CoursesTable = ({
	courses,
	setCourseToEdit,
	deleteCourse,
	openModal1,
}) => {
	const [data, setData] = useState(courses);
	const jsonValue = localStorage.getItem("userLocal");
	const localUser = JSON.parse(jsonValue);
	useEffect(() => {
		setData(courses);
	}, [courses]);

	function handleSearch(e) {
		if (e.target.value === "") {
			return setData(courses);
		}
		setData(
			courses.filter(
				(item) =>
					item.nameCourse.toLowerCase().includes(e.target.value) ||
					item.descriptionCourse.toLowerCase().includes(e.target.value)
			)
		);
	}

	return (
		<div>
			{/* {console.log("data", data)} */}
			<div className="document-search">
				<h2 className="title-search">Buscar</h2>
				<input
					type="search"
					name=""
					id=""
					onChange={handleSearch}
					className="search-box"
				/>
			</div>
			<h3 className="titulo1">LISTA DE CURSOS</h3>
			<table className="tabla-procesos">
				<thead>
					<tr className="fila-tabla-procesos">
						{/* <th className="titleTableDocuments01">Area</th> */}
						<th className="titleTableDocuments02">Curso</th>
						<th className="titleTableDocuments03">Descripcion</th>
						<th className="titleTableDocuments03">Material</th>
						<th className="titleTableDocuments03">Evaluación</th>
						{localUser.type === "1" && (
							<th className="titleTableDocuments03">Empresas</th>
						)}
						<th className="titleTableDocuments03">Fecha</th>

						<th className="titleTableDocuments03">Acción</th>
					</tr>
				</thead>
				<tbody>
					{data.length > 0 ? (
						data.map((el) => (
							<CoursesTableRow
								key={el.id}
								el={el}
								setCourseToEdit={setCourseToEdit}
								deleteCourse={deleteCourse}
								openModal1={openModal1}
							/>
						))
					) : (
						<tr>
							<td colSpan="3">Sin datos</td>
						</tr>
					)}
				</tbody>
			</table>
		</div>
	);
};
